<template>
  <div class="channel-access">
    <div class="breadcrumb">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>接入</el-breadcrumb-item>
        <el-breadcrumb-item>渠道接入</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="page-header">
      <div class="api-header">
        <div class="section-title">API</div>
      </div>

      <el-row :gutter="20" class="api-row">
        <el-col :span="8">
          <div class="api-card">
            <div class="api-icon">
              <i class="el-icon-chat-dot-round"></i>
            </div>
            <div class="api-content">
              <div class="api-title">对话 API</div>
              <div class="api-desc">将应用或工作流的对话能力接入您的应用</div>
            </div>
            <el-button type="text" class="doc-btn">文档</el-button>
          </div>
        </el-col>

        <el-col :span="8">
          <div class="api-card">
            <div class="api-icon">
              <i class="el-icon-chat-line-square"></i>
            </div>
            <div class="api-content">
              <div class="api-title">带记忆的对话 API</div>
              <div class="api-desc">兼容应用和工作流的上下文记忆设置，无需单独传入上下文</div>
            </div>
            <el-button type="text" class="doc-btn">文档</el-button>
          </div>
        </el-col>

        <el-col :span="8">
          <div class="api-card">
            <div class="api-icon">
              <i class="el-icon-set-up"></i>
            </div>
            <div class="api-content">
              <div class="api-title">工作流运行 API</div>
              <div class="api-desc">可传入工作流变量运行工作流</div>
            </div>
            <el-button type="text" class="doc-btn">文档</el-button>
          </div>
        </el-col>
      </el-row>

      <div class="api-key-section">
        <div class="api-key-header">
          <div class="api-key-title">API Key 管理</div>
          <el-tooltip content="API Key 是调用 API 的凭证">
            <i class="el-icon-question"></i>
          </el-tooltip>
          <el-button type="primary" size="small" plain icon="el-icon-plus" class="create-key-btn">创建API Key</el-button>
        </div>

        <el-table :data="apiKeys" style="width: 100%" class="api-key-table"
          :header-cell-style="{ backgroundColor: '#F5F7FA', color: '#606266', fontWeight: '600' }" border>
          <el-table-column prop="name" label="名称" width="100"></el-table-column>
          <el-table-column prop="key" label="Key" width="220">
            <template slot-scope="scope">
              <div class="key-column">
                <el-tooltip :content="scope.row.key" placement="top" effect="light">
                  <span class="key-value">{{ scope.row.key | maskKey }}</span>
                </el-tooltip>
                <el-button type="text" class="copy-btn" @click="copyKey(scope.row)">
                  <i class="el-icon-document-copy"></i>
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createdAt" label="创建时间" width="130">
            <template slot-scope="scope">
              <span class="date-value">{{ scope.row.createdAt }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="lastUsed" label="最后使用时间" width="130">
            <template slot-scope="scope">
              <span class="date-value">{{ scope.row.lastUsed }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="80" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 'active' ? 'success' : 'danger'" size="mini" class="status-tag">
                {{ scope.row.status === 'active' ? '正常' : '停用' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="120" align="center">
            <template slot-scope="scope">
              <div class="action-buttons">
                <el-button type="text" class="action-btn" @click="disableKey(scope.row)"
                  v-if="scope.row.status === 'active'">
                  停用
                </el-button>
                <el-button type="text" class="action-btn enable-btn" @click="enableKey(scope.row)" v-else>
                  启用
                </el-button>
                <el-button type="text" class="action-btn danger-text" @click="deleteKey(scope.row)">
                  删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="section-title">网站集成</div>

    <div class="website-card">
      <div class="website-header">
        <div class="website-icon">
          <i class="el-icon-monitor"></i>
        </div>
        <div class="website-title">网页嵌入</div>
        <div class="website-desc">打造你的网页客服机器人</div>
        <el-button size="small" class="connect-btn">接入</el-button>
      </div>
    </div>

    <div class="section-title">客户运营</div>

    <el-row :gutter="20">
      <el-col :span="8" v-for="(channel, index) in customerChannels" :key="index">
        <div class="channel-card">
          <div class="channel-header">
            <div class="channel-icon" :class="channel.iconClass">
              <i :class="channel.icon"></i>
            </div>
            <div class="channel-info">
              <div class="channel-name">{{ channel.name }}</div>
              <div class="channel-desc">{{ channel.description }}</div>
            </div>
            <el-button type="primary" size="small" plain>{{ channel.buttonText }}</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'ChannelAccess',
  data () {
    return {
      apiKeys: [
        {
          name: '测试Key',
          key: 'sk-1234567890abcdef1234567890abcdef',
          createdAt: '2024-05-01 10:00:00',
          lastUsed: '2024-05-14 15:30:45',
          status: 'active'
        },
        {
          name: '生产环境',
          key: 'sk-abcdef1234567890abcdef1234567890',
          createdAt: '2024-04-15 14:30:00',
          lastUsed: '2024-05-15 09:12:33',
          status: 'active'
        },
        {
          name: '旧版本',
          key: 'sk-0987654321fedcba0987654321fedcba',
          createdAt: '2024-03-20 09:45:00',
          lastUsed: '2024-04-10 11:25:17',
          status: 'disabled'
        }
      ],
      customerChannels: [
        {
          name: '微信公众号',
          description: '一键接入你的公众号',
          icon: 'el-icon-chat-line-round',
          iconClass: 'wechat-color',
          buttonText: '接入'
        },
        {
          name: '企业微信',
          description: '打通企微客服体系',
          icon: 'el-icon-office-building',
          iconClass: 'work-wechat-color',
          buttonText: '接入'
        },
        {
          name: '钉钉',
          description: '接入钉钉，快速搭建内部助手',
          icon: 'el-icon-bell',
          iconClass: 'dingtalk-color',
          buttonText: '接入'
        }
      ]
    };
  },
  filters: {
    maskKey (key) {
      if (!key) return '';
      const prefix = key.substring(0, 6);
      const suffix = key.substring(key.length - 4);
      return `${prefix}...${suffix}`;
    }
  },
  methods: {
    copyKey (row) {
      this.$message.success(`${row.name} 的 API Key 已复制到剪贴板`);
    },
    disableKey (row) {
      this.$confirm(`确认停用 ${row.name} 的 API Key?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        row.status = 'disabled';
        this.$message.success('停用成功');
      }).catch(() => {
        this.$message.info('已取消操作');
      });
    },
    enableKey (row) {
      row.status = 'active';
      this.$message.success('启用成功');
    },
    deleteKey (row) {
      this.$confirm(`删除后无法恢复，确认删除 ${row.name} 的 API Key?`, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.apiKeys = this.apiKeys.filter(item => item.key !== row.key);
        this.$message.success('删除成功');
      }).catch(() => {
        this.$message.info('已取消操作');
      });
    },
    formatDate (dateString) {
      const date = new Date(dateString);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    }
  }
};
</script>

<style scoped>
.channel-access {
  padding-bottom: 50px;
}

.breadcrumb {
  margin-bottom: 20px;
}

.page-header {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  padding: 20px;
  margin-bottom: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 20px;
}

.api-row {
  margin-bottom: 30px;
}

.api-card {
  display: flex;
  align-items: center;
  padding: 15px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  position: relative;
}

.api-icon {
  width: 40px;
  height: 40px;
  background-color: #ecf5ff;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #409EFF;
  margin-right: 12px;
}

.api-content {
  flex: 1;
}

.api-title {
  font-weight: 600;
  color: #303133;
  margin-bottom: 5px;
}

.api-desc {
  font-size: 12px;
  color: #606266;
}

.doc-btn {
  position: absolute;
  right: 15px;
  top: 30%;
  transform: translateY(-50%);
}

.api-key-section {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  padding: 20px;
  margin-bottom: 30px;
}

.api-key-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.api-key-title {
  font-weight: 600;
  font-size: 16px;
  color: #303133;
  margin-right: 8px;
}

.api-key-header .el-icon-question {
  font-size: 16px;
  color: #909399;
  cursor: pointer;
  margin-right: 5px;
}

.create-key-btn {
  margin-left: auto;
}

/* API Key表格美化样式 */
.api-key-table {
  border-radius: 4px;
  overflow: hidden;
  font-size: 13px;
}

.api-key-table .el-table__row {
  height: 50px;
}

/* 确保所有单元格内容单行显示 */
.el-table .cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Key列样式 */
.key-column {
  display: flex;
  align-items: center;
}

.key-value {
  font-family: monospace;
  color: #606266;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.copy-btn {
  padding: 2px 4px;
  margin-left: 5px;
  font-size: 12px;
  color: #409EFF;
}

/* 日期列样式 */
.date-value {
  white-space: nowrap;
}

/* 状态标签样式 */
.status-tag {
  padding: 2px 8px;
}

/* 操作按钮样式 */
.action-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  gap: 8px;
}

.action-btn {
  padding: 0;
  font-size: 13px;
  height: auto;
  min-height: auto;
}

.enable-btn {
  color: #67C23A;
}

.danger-text {
  color: #F56C6C;
}

.website-card {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  margin-bottom: 30px;
}

.website-header {
  padding: 20px;
  display: flex;
  align-items: center;
}

.website-icon {
  width: 50px;
  height: 50px;
  background-color: #ecf5ff;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #409EFF;
  margin-right: 15px;
}

.website-title {
  font-weight: 600;
  font-size: 16px;
  color: #303133;
  margin-right: 10px;
}

.website-desc {
  color: #606266;
  font-size: 14px;
  flex: 1;
}

.connect-btn {
  margin-left: auto;
}

.channel-card {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
  min-height: 100px;
}

.channel-header {
  padding: 20px;
  display: flex;
  align-items: center;
}

.channel-icon {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #fff;
  margin-right: 12px;
}

.wechat-color {
  background-color: #07C160;
}

.work-wechat-color {
  background-color: #2A80FF;
}

.dingtalk-color {
  background-color: #2BADFF;
}

.channel-info {
  flex: 1;
}

.channel-name {
  font-weight: 600;
  color: #303133;
  margin-bottom: 5px;
}

.channel-desc {
  font-size: 12px;
  color: #606266;
}
</style>